import { HttpClient, NonNullablePaths } from '@wix/sdk-types';
import {
  GetCookieBannerSettingsOptions,
  GetCookieBannerSettingsResponse,
  InstallCookieBannerOptions,
  UpdateCookieBannerSettingsOptions,
  UpdateCookieBannerSettingsResponse,
  getCookieBannerSettings as universalGetCookieBannerSettings,
  installCookieBanner as universalInstallCookieBanner,
  updateCookieBannerSettings as universalUpdateCookieBannerSettings,
} from './wixpress-cookie-banner-settings-v1-cookie-banner-settings-cookie-banner-settings.universal.js';

export const __metadata = { PACKAGE_NAME: '@wix/consent-policy' };

/** @internal */
export function installCookieBanner(
  httpClient: HttpClient
): InstallCookieBannerSignature {
  return (options?: InstallCookieBannerOptions) =>
    universalInstallCookieBanner(
      options,
      // @ts-ignore
      { httpClient }
    );
}

interface InstallCookieBannerSignature {
  /** */
  (options?: InstallCookieBannerOptions): Promise<void>;
}

export function getCookieBannerSettings(
  httpClient: HttpClient
): GetCookieBannerSettingsSignature {
  return (options?: GetCookieBannerSettingsOptions) =>
    universalGetCookieBannerSettings(
      options,
      // @ts-ignore
      { httpClient }
    );
}

interface GetCookieBannerSettingsSignature {
  /**
   * Retrieves the cookie banner settings.
   * @param - Field options.
   */
  (options?: GetCookieBannerSettingsOptions): Promise<
    NonNullablePaths<
      GetCookieBannerSettingsResponse,
      | `settings.appEnabled`
      | `settings.audience`
      | `settings.cookiePolicyRequirementApproved`
      | `settings.declineAllConfig.enabled`
      | `settings.declineAllConfig.geo`
      | `settings.privacyPolicyPage`
      | `settings.privacyPolicyType`
      | `settings.theme`
      | `settings.revisitSettingsConfig.enabled`
      | `settings.revisitSettingsConfig.buttonPosition`
      | `settings.customThemeConfig.primaryColor.value`
      | `settings.customThemeConfig.fontFamily`
      | `settings.customThemeConfig.fontSize`
      | `settings.customThemeConfig.cornerRadius`
      | `settings.enabled`
      | `settings.privacyPolicyPageInfo.slugDetails.slug`
      | `settings.privacyPolicyPageInfo.externalPageUrlDetails.externalPageUrl`
      | `settings.privacyPolicyPageInfo.privacyPolicyDetailsReferenceType`,
      5
    >
  >;
}

export function updateCookieBannerSettings(
  httpClient: HttpClient
): UpdateCookieBannerSettingsSignature {
  return (options?: UpdateCookieBannerSettingsOptions) =>
    universalUpdateCookieBannerSettings(
      options,
      // @ts-ignore
      { httpClient }
    );
}

interface UpdateCookieBannerSettingsSignature {
  /**
   * Updates the cookie banner settings.
   * @param - Field options.
   */
  (options?: UpdateCookieBannerSettingsOptions): Promise<
    NonNullablePaths<
      UpdateCookieBannerSettingsResponse,
      | `settings.appEnabled`
      | `settings.audience`
      | `settings.cookiePolicyRequirementApproved`
      | `settings.declineAllConfig.enabled`
      | `settings.declineAllConfig.geo`
      | `settings.privacyPolicyPage`
      | `settings.privacyPolicyType`
      | `settings.theme`
      | `settings.revisitSettingsConfig.enabled`
      | `settings.revisitSettingsConfig.buttonPosition`
      | `settings.customThemeConfig.primaryColor.value`
      | `settings.customThemeConfig.fontFamily`
      | `settings.customThemeConfig.fontSize`
      | `settings.customThemeConfig.cornerRadius`
      | `settings.enabled`
      | `settings.privacyPolicyPageInfo.slugDetails.slug`
      | `settings.privacyPolicyPageInfo.externalPageUrlDetails.externalPageUrl`
      | `settings.privacyPolicyPageInfo.privacyPolicyDetailsReferenceType`,
      5
    >
  >;
}

export {
  Audience,
  ButtonPosition,
  Channel,
  ConsentPolicy,
  CookieBannerSettings,
  CornerRadius,
  CustomThemeConfig,
  DeclineAllConfig,
  DeleteCookieBannerPreviewSettingsRequest,
  DeleteCookieBannerPreviewSettingsResponse,
  ExternalPageUrlDetails,
  GetChannelPermissionsRequest,
  GetChannelPermissionsResponse,
  GetCookieBannerPreviewSettingsRequest,
  GetCookieBannerPreviewSettingsResponse,
  GetCookieBannerSettingsOptions,
  GetCookieBannerSettingsRequest,
  GetCookieBannerSettingsResponse,
  InstallCookieBannerOptions,
  InstallCookieBannerRequest,
  InstallCookieBannerResponse,
  PrivacyPolicyDetailsReferenceType,
  PrivacyPolicyPageInfo,
  PrivacyPolicyPageInfoDetailsOneOf,
  PrivacyPolicyType,
  RevisitSettingsConfig,
  SetCookieBannerPreviewSettingsRequest,
  SetCookieBannerPreviewSettingsResponse,
  SetCookieBannerSettingsRequest,
  SetCookieBannerSettingsResponse,
  SiteColor,
  SlugDetails,
  Subscriber,
  Theme,
  UpdateCookieBannerSettingsOptions,
  UpdateCookieBannerSettingsRequest,
  UpdateCookieBannerSettingsResponse,
} from './wixpress-cookie-banner-settings-v1-cookie-banner-settings-cookie-banner-settings.universal.js';
